export function updatePartNumberDisplay(button) {
  const partNumber = button.dataset.partNumber
  const customerPartNumber = button.dataset.customerPartNumber
  const displayElement = document.querySelector('.customer-part-number')
  
  if (!displayElement) return
  
  if (shouldShowCrossReference(partNumber, customerPartNumber)) {
    displayElement.innerHTML = `<p>(${partNumber} - Cross Reference Part Number: ${customerPartNumber})</p>`
  } else {
    displayElement.innerHTML = ''
  }
}

export function shouldShowCrossReference(partNumber, customerPartNumber) {
  if (!customerPartNumber) return false
  
  const cleanPartNumber = cleanString(partNumber)
  const cleanCustomerPartNumber = cleanString(customerPartNumber)
  
  return cleanCustomerPartNumber !== cleanPartNumber
}

function cleanString(str) {
  return str ? String(str).replace(/[^a-zA-Z0-9.]/g, '') : ''
}

export function getPriceBreaks(button) {
  if (!button?.dataset.priceBreaks) return []
  
  try {
    return JSON.parse(button.dataset.priceBreaks)
  } catch (e) {
    console.error('Failed to parse price breaks:', e)
    return []
  }
}

